/**
 * Handle behavior for the in-page navigation block.
 */
const inPageNavigation = {
	isScrollingProgrammatically: false,
	 /**
		 * Entry Point
		 */
	_init: () => {
		// listen for document ready.
		document.addEventListener('DOMContentLoaded', inPageNavigation._ready);
		document.addEventListener('scrollend', inPageNavigation._scrollHandler);
	},
	_ready: () => {
		const inPageNav = document.querySelector('.in-page-navigation');
		
		inPageNav.addEventListener('click', inPageNavigation._handleNavClick);
		inPageNavigation._scrollObserver();
	}, 
	_scrollObserver: () => {
		const inPageNavLinks = document.querySelectorAll('.in-page-navigation-wrapper-item-link');
		const rootStyles = getComputedStyle(document.documentElement);
		const headerBarHeight = parseFloat(rootStyles.getPropertyValue('--header-height').trim());
		const NavHeight = rootStyles.getPropertyValue('--nav-height').trim();
		const headerNavHeight = parseFloat(headerBarHeight) + parseFloat(NavHeight);
		
		const options = {
			root: null,
			rootMargin: `-${headerNavHeight}px 0px -50% 0px`,
			threshold: 0,
		}
		
		const observables = [];
		inPageNavLinks.forEach((link) => {
			let linkID = link.getAttribute('href').substring(1);
			let observableElem = document.getElementById(linkID);
			
			if (observableElem) observables.push(observableElem);
		})
		
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (inPageNavigation.isScrollingProgrammatically) return;
				
				const link = document.querySelector(`.in-page-navigation-wrapper-item-link[href="#${entry.target.id}"]`);
				if (!link) return;

				const inPageNavLinks = document.querySelectorAll('.in-page-navigation-wrapper-item-link');
				if (entry.isIntersecting) {
					inPageNavLinks.forEach(link => {
						link.classList.remove('active');
					});
					link.classList.add('active');
				}
			})
		}, options);

		observables.forEach(observable => {
			observer.observe(observable)
		});
	},
	_handleNavClick: (e) => {
		const link = e.target.closest('.in-page-navigation-wrapper-item-link');
		
		if (link) {
			e.preventDefault();
			
			const targetId = link.getAttribute('href').substring(1);
			const targetElement = document.getElementById(targetId);
			inPageNavigation.isScrollingProgrammatically = true;
			
			if (targetElement) {
				const rootStyles = getComputedStyle(document.documentElement);
				const headerBarHeight = parseFloat(rootStyles.getPropertyValue('--header-height-expanded').trim());
				const NavHeight = parseFloat(rootStyles.getPropertyValue('--nav-height').trim());
				const headerNavHeight = parseFloat(headerBarHeight) + parseFloat(NavHeight);

				// scroll to div with hash for id.
				window.scrollTo({
					top: targetElement.offsetTop - headerNavHeight,
					behavior: 'smooth'
				});
				
				history.replaceState(undefined, undefined, e.target.href);
				inPageNavigation._setActiveLink(link);
			}
		}
	},
	_setActiveLink: (activeLink) => {
		const links = document.querySelectorAll('.in-page-navigation-wrapper-item-link');
		
		links.forEach((link) => {
			link.classList.remove('active');
		});
		
		activeLink.classList.add('active');
	},
	_scrollHandler: () => {
		inPageNavigation.isScrollingProgrammatically = false;
	}
 }

// Initialize the in-page navigation.
inPageNavigation._init();
